module.exports = __webpack_public_path__ + "media/images/flags/mz-dac5f7ee4f2a02e79de217bea9f79849.svg";